/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Invitation_Projects_LabelInputs */

const es_co2_signup_invitation_projects_label = /** @type {(inputs: Signup_Invitation_Projects_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te unirás a estos proyectos:`)
};

/**

* @param {Signup_Invitation_Projects_LabelInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_invitation_projects_label = /** @type {((inputs?: Signup_Invitation_Projects_LabelInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Invitation_Projects_LabelInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_invitation_projects_label(inputs)
});